import React, { useState, useEffect } from "react";
import {
  Text,
  Button,
  ScrollBox,
  Image,
  LicensePlate,
} from "../Index";
import CloseIcon from "../../assets/Icon/close.svg";
import AddIcon from "../../assets/Icon/add.svg";
import { useCars } from "../../Context/CarContext";
import { useNavigate } from "react-router-dom";
import "./selectCarPop.scss";

function SelectCarPop({ isOpen, onClose, onConfirm, matchCardWidth = false }) {
  const [tempSelectedCarId, setTempSelectedCarId] = useState(null);
  const { getAllCars, getSelectedCar, refreshCars, loading: carsLoading } = useCars();
  const navigate = useNavigate();

  const [cars, setCars] = useState([]);

  useEffect(() => {
    if (isOpen) {
      const carData = getAllCars();
      setCars(carData);
      const selectedCar = getSelectedCar();
      if (selectedCar) {
        setTempSelectedCarId(selectedCar.id);
      }
    }
  }, [isOpen, getAllCars, getSelectedCar]);

  useEffect(() => {
    if (isOpen) {
      refreshCars();
    }
  }, [isOpen, refreshCars]);

  const handleCarSelect = (carId) => {
    setTempSelectedCarId(carId);
  };

  const handleConfirm = () => {
    if (tempSelectedCarId && onConfirm) {
      onConfirm(tempSelectedCarId);
    }
    onClose();
  };

  const handleAddNewCar = () => {
    onClose();
    navigate("/AddCars");
  };

  if (!isOpen) return null;

  return (
    <div
      className={`select-car-pop-overlay${matchCardWidth ? " select-car-pop-overlay--card-width" : ""}`}
      onClick={onClose}
    >
      <div
        className={`select-car-pop-container${matchCardWidth ? " select-car-pop-container--card-width" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="select-car-pop-header">
          <Text FontWight="Bold" FontSize="lg" position="right">
            انتخاب ماشین
          </Text>
          <button
            className="select-car-pop-close"
            onClick={onClose}
            aria-label="بستن"
          >
            <img src={CloseIcon} alt="" />
          </button>
        </div>

        <div className="select-car-pop-scroll">
          <ScrollBox height="100%">
            <div className="select-car-pop-cars">
            {carsLoading ? (
              <Text position="center" FontSize="md" color="gray">
                در حال بارگذاری...
              </Text>
            ) : cars.map((car) => (
              <div
                key={car.id}
                className={`select-car-pop-car-card ${tempSelectedCarId === car.id ? "selected" : ""}`}
                onClick={() => handleCarSelect(car.id)}
              >
                <div className="select-car-pop-car-main">
                  <div className="select-car-pop-car-image-wrapper">
                    <Image src={car.Src} />
                  </div>
                  <div className="select-car-pop-car-info">
                    <Text FontWight="Bold" FontSize="md" position="right">
                      {car.CarModel}
                    </Text>
                    <Text FontSize="sm" position="right" className="car-detail">
                      سال ساخت: {car.ProductionYear}
                    </Text>
                    <Text FontSize="sm" position="right" className="car-detail">
                      رنگ: {car.CarColor}
                    </Text>
                    <Text FontSize="sm" position="right" className="car-detail">
                      کیلومتر: {car.Km}
                    </Text>
                  </div>
                </div>
                <LicensePlate
                  Main1={car.Plate1}
                  Main2={car.Plate2}
                  Main3={car.Plate3}
                  End={car.End}
                  compact
                />
                {tempSelectedCarId === car.id && (
                  <div className="select-car-pop-checkmark">
                    <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23142642'%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z'/%3E%3C/svg%3E" alt="انتخاب شده" />
                  </div>
                )}
              </div>
            ))}
            {cars.length === 0 && !carsLoading && (
              <div className="select-car-pop-empty">
                <Text position="center" FontSize="md" color="gray">
                  هیچ ماشینی ثبت نشده است
                </Text>
              </div>
            )}
            <button
              className="select-car-pop-add-car"
              onClick={handleAddNewCar}
              type="button"
            >
              <div className="select-car-pop-add-icon-wrapper">
                <img src={AddIcon} alt="" className="select-car-pop-add-icon" />
              </div>
              <Text FontWight="Bold" FontSize="md" position="right" className="add-car-text">
                ثبت ماشین جدید
              </Text>
            </button>
          </div>
        </ScrollBox>
        </div>

        <div className="select-car-pop-footer">
          <Button size="full" color="dark" onClick={handleConfirm} disabled={!tempSelectedCarId || carsLoading}>
            تایید ماشین
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SelectCarPop;